import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        weeeFeeText: {
            textStyle: 'body-xsmall',
            color: 'foreground.neutral.subtle',
        },
        weeeFeeBadgeText: {
            textStyle: 'body-xxsmall',
            textTransform: 'uppercase',
            fontWeight: 'bold',
            color: 'text.success',
            lineHeight: 'normal',
            whiteSpace: 'nowrap',
        },
        weeeFeeContainer: {
            gap: remCalc(0),
        },
        weeeFeeLabel: {
            gap: remCalc(8),
        },
        infoIconContainer: {
            display: 'flex',
            alignItems: 'center',
        },
        leadingIconContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        leadingIcon: {
            boxSize: 'iconsSize.xsmall',
            color: 'currentColor',
        },
        infoIcon: {
            boxSize: 'iconsSize.small',
            cursor: 'pointer',
        },
    },
    variants: {
        productView: {
            weeeFeeContainer: {
                alignItems: 'center',
                display: 'inline-flex',
                justifyContent: 'center',
                borderRadius: 'medium-1',
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'border.neutral.highlight',
                backgroundColor: 'background.positive.muted',
                boxShadow: '0 0 0 1px var(--positive-lg, rgba(0, 105, 51, 0.24))',
                backdropFilter: 'blur(calc(var(--sm, 8px) / 2))',
                height: remCalc(22),
                px: ['xxxsmall.base', 'xxxsmall.md', 'xxxsmall.lg', 'xxxsmall.xl'],
                py: ['xxsmall.base', 'xxsmall.md', 'xxsmall.lg', 'xxsmall.xl'],
                gap: ['xxxsmall.base', 'xxxsmall.md', 'xxxsmall.lg', 'xxxsmall.xl'],
            },
            weeeFeeLabel: {
                gap: ['xxxsmall.base', 'xxxsmall.md', 'xxxsmall.lg', 'xxxsmall.xl'],
                alignItems: 'center',
            },
            weeeFeeBadgeText: {
                color: 'foreground.positive.default',
                textTransform: 'uppercase',
                textStyle: 'body-xxsmall',
                fontWeight: 'bold',
                lineHeight: 'normal',
                backgroundColor: 'transparent',
                px: 0,
                py: 0,
                borderRadius: 0,
            },
            leadingIconContainer: {
                width: remCalc(12),
                height: remCalc(12),
                aspectRatio: '1 / 1',
                color: 'border.positive.default',
            },
            leadingIcon: {
                boxSize: remCalc(12),
                color: 'currentColor',
            },
            infoIconContainer: {
                width: remCalc(12),
                height: remCalc(12),
                aspectRatio: '1 / 1',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: 'foreground.neutral.default',
                borderColor: 'border.positive.default',
            },
            infoIcon: {
                boxSize: remCalc(14),
                color: 'currentColor',
            },
        },
        orderSummary: {
            weeeFeeText: {
                textStyle: 'body-small',
                color: 'foreground.neutral.default',
            },
            weeeFeeContainer: {
                justifyContent: 'space-between',
                paddingY: remCalc(12),
                gap: remCalc(8),
                width: '100%',
            },
        },
    },
    parts: [
        'weeeFeeText',
        'weeeFeeBadgeText',
        'weeeFeeContainer',
        'weeeFeeLabel',
        'leadingIconContainer',
        'leadingIcon',
        'infoIconContainer',
        'infoIcon',
    ],
}
